import { filterOutFnfComponents } from 'components/SalaryComponents/utils';
import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  GetEmployeeAdditionsDeductionsQueryVariables,
  GetEmployeeAdditionsDeductionsResponse,
} from '../types';

const getEmployeeAdditionsDeductionsQuery = gql`
  query PayrollGetEmployeeAdditionsDeductions(
    $userId: String!
    $effectiveFrom: String!
    $effectiveTo: String!
    $payType: PayTypeFilter
  ) {
    payrollGetEmployeeAdditionsDeductions(
      userId: $userId
      effectiveFrom: $effectiveFrom
      effectiveTo: $effectiveTo
      payType: $payType
    ) {
      data {
        additions {
          id
          userId
          amount
          effectiveFrom
          effectiveTo
          type
          additionalSdiData
          componentDetails {
            id
            name
            description
            defaultFormula
            category
            settings {
              behaviour {
                pfBehaviour {
                  includeInPfWages
                }
                ptBehaviour {
                  includeInPtWages
                }
                esiBehaviour {
                  includeInEsiWages
                }
                lwfBehaviour {
                  includeInLwfWages
                }
                taxBehaviour {
                  taxExemptionSection
                  taxDeductionBehaviour
                  taxExemptInNewRegime
                  taxExemptInOldRegime
                }
                arrearBehaviour {
                  considerInArrear
                }
                prorationBehaviour {
                  supportProration
                }
                displayBehaviour {
                  showZero
                  visibleToEmployee
                  displayName
                }
              }
              earningDetails {
                payType
              }
              deductionDetails {
                deductionType
                deductFrom
              }
              bonusDetails {
                clawbackDuration
                isTaxable
              }
              perquisiteDetails {
                isTaxable
              }
              nonPayableBenefitsDetails {
                isPartOfCTC
                visibilityToEmployee
              }
            }
            isPredefined
            isActive
            source
            # componentType
          }
        }
        deductions {
          id
          userId
          amount
          effectiveFrom
          effectiveTo
          type
          additionalSdiData
          componentDetails {
            id
            name
            description
            defaultFormula
            category
            settings {
              behaviour {
                pfBehaviour {
                  includeInPfWages
                }
                ptBehaviour {
                  includeInPtWages
                }
                esiBehaviour {
                  includeInEsiWages
                }
                lwfBehaviour {
                  includeInLwfWages
                }
                taxBehaviour {
                  taxExemptionSection
                  taxDeductionBehaviour
                  taxExemptInNewRegime
                  taxExemptInOldRegime
                }
                arrearBehaviour {
                  considerInArrear
                }
                prorationBehaviour {
                  supportProration
                }
                displayBehaviour {
                  showZero
                  visibleToEmployee
                  displayName
                }
              }
              earningDetails {
                payType
              }
              deductionDetails {
                deductionType
                deductFrom
              }
              bonusDetails {
                clawbackDuration
                isTaxable
              }
              perquisiteDetails {
                isTaxable
              }
              nonPayableBenefitsDetails {
                isPartOfCTC
                visibilityToEmployee
              }
            }
            isPredefined
            isActive
            source
            # componentType
          }
        }
        lopData {
          peopleId
          lopDays
        }
      }
      code
      success
      message
    }
  }
`;

const filterResponse = (response: GetEmployeeAdditionsDeductionsResponse) => {
  const additions = response.payrollGetEmployeeAdditionsDeductions.data.additions;
  const deductions = response.payrollGetEmployeeAdditionsDeductions.data.deductions;
  const filteredAdditions = filterOutFnfComponents(additions);
  const filteredDeductions = filterOutFnfComponents(deductions);
  return {
    ...response,
    payrollGetEmployeeAdditionsDeductions: {
      ...response.payrollGetEmployeeAdditionsDeductions,
      data: {
        ...response.payrollGetEmployeeAdditionsDeductions.data,
        additions: filteredAdditions,
        deductions: filteredDeductions,
      },
    },
  };
};

const getEmployeeAdditionsDeductions = async (
  queryVariables: GetEmployeeAdditionsDeductionsQueryVariables,
) => {
  try {
    const response = await graphQLApi<
      GetEmployeeAdditionsDeductionsResponse,
      GetEmployeeAdditionsDeductionsQueryVariables
    >({
      query: getEmployeeAdditionsDeductionsQuery,
      queryVariables,
    });
    if (queryVariables.includeFnfComponents) {
      return response;
    }
    return filterResponse(response);
  } catch (e) {
    throw e;
  }
};

export default getEmployeeAdditionsDeductions;
